/** Back in stock
 * custom notify-popup
 * https://help.backinstock.org/article/2303-javascript-api
 **/
class NotifyMe extends HTMLElement {
    constructor() {
        super();
        this.selectedVariant = null;
        this.trigger         = document.querySelector(".notify_button");
        this.buttonSubmit    = this.querySelector('#notify_me');
        this.email           = this.querySelector('#notify_email');
        this.select          = document.querySelector('#notify_variant');
        this.dialog          = this.querySelector(".dialog__notify-me");
        this.dialogContainer = this.querySelector('.dialog__body');
        this.dialog_notify   = this.querySelector(".dialog__success");
        this.email_error     = this.querySelector(".error_notification");
        this.close_dialog    = this.querySelector("#close-notify");
        const variantsElement = document.querySelector(".all-variants");
        this.variants = variantsElement?.innerText ? JSON.parse(variantsElement.innerText) : [];
        this.product_id      = this.select.dataset.product;
        this.notifyTitle = this.querySelector('#notify_title');
        this.notifyTitleSuccess = this.querySelector('#notify_title_success');

        this.buildSelect(this.findVariants(this.color));

        this.addEvents();

        document.addEventListener("click", this.closeDialog.bind(this));
        document.addEventListener('variant:changed', (e) => {
            const variant = e.detail.variantValue;
            this.buildSelect(this.findVariants(variant));
            this.select.value = variant.id;
        });

    }

    buildSelect(variants){
        this.select.innerHTML = '';

        // Creiamo le options
        variants.forEach(variant => {
            let option = document.createElement("option");
            option.text = variant.title;
            option.value = variant.id;
            this.select.appendChild(option);
        });

        const variantId = variants[0]?.id || '';

        this.selectedVariant = this.getSelectedVariant(variantId);
    }

    getSelectedVariant(variantId){
        const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
        return variantFromUrl || variantId;
    }

    findVariants(color){
        // effettuare il controllo su color se presente all'interno di return
        //Object.entries(this.allVariants)
        const object = Object.entries(this.variants)
            .filter(([key, value]) => (value.option1 === color && value.available == false))
            .map(([key, value]) => value);

        return object;
    }

    openDialog() {
        this.dialog.showModal();
    }

    closeDialog(event) {
        if (event.target.matches("#close-notify, #close-notify *") || event.target.matches(".dialog__success button, .dialog__success button label")){
            this.dialog.close();
        }
        if (!event.target.contains(this.dialog)) return;
        this.dialog.close();
    }

    addEvents() {
        const self = this;
        this.trigger.addEventListener('click', e=> {
            e.preventDefault();
            this.dialogContainer.classList.remove("hidden");
            this.dialog_notify.classList.add("hidden");

            self.openDialog();
        })
        this.buttonSubmit.addEventListener('click', async (event)=> {
            event.preventDefault();
            this.createBIS.bind(this)()
        })

        this.email.addEventListener("click", ()=>{
            if(this.email.closest(".field_email").classList.contains("field--error")){
                this.email.closest(".field_email").classList.remove("field--error");
                this.email_error.classList.add("hidden");
            }
        });
        this.close_dialog.addEventListener("click", this.closeDialog.bind(this));
    }

    async createBIS() {

        const email       = this.email.value,
            variantId   = this.selectedVariant;

        const email_regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*')@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

        if (!email.match(email_regex)) {
            this.email.closest(".field_email").classList.add('field--error');
            this.email_error.classList.remove("hidden");
            return
        }

        this.email.closest(".field_email").classList.remove('field--error');
        // Back in stock API
        const data = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ['EMAIL'],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: `${email}`
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantId}`
                        }
                    }
                }
            }
        }


        await fetch(window.klaviyo.api, {
            method: "POST",
            headers: {
                "accept": "application/vnd.api+json",
                "content-type": "application/vnd.api+json",
                "revision": "2024-10-15",
            },
            body: JSON.stringify(data),
        })
        this.notificationCallback()

        fbq('track', 'CompleteRegistration');

    }


    notificationCallback(){
        this.classList.add('notification');
        this.dialogContainer.classList.add("hidden");
        this.dialog_notify.classList.remove("hidden");
        this.notifyTitle.classList.add("hidden");
        this.notifyTitleSuccess.classList.remove("hidden");
        this.email.value = "";
    }
}
customElements.define('notify-me', NotifyMe);